<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="10" class="icon-arrow" :class="{'icon-arrow_bottom': bottom}">
    <use class="svg-colorized-el" xlink:href="#icon-arrow_fill"/>
    <defs>
      <path id="icon-arrow_fill" d="M5 6H1a1 1 0 0 1 0-2h4a1 1 0 0 0 1-1v-.865a1 1 0 0 1 1.64-.768l3.438 2.865a1 1 0 0 1 0 1.536L7.64 8.633A1 1 0 0 1 6 7.865V7a1 1 0 0 0-1-1z"/>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    bottom: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  .icon-arrow_bottom {
    transform: rotate(90deg);
  }
</style>


// WEBPACK FOOTER //
// src/components/icons/IconArrowMax.vue